import { render, staticRenderFns } from "./MenuTopHeader.vue?vue&type=template&id=bc807272&scoped=true"
import script from "./MenuTopHeader.vue?vue&type=script&lang=js"
export * from "./MenuTopHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc807272",
  null
  
)

export default component.exports